import { useEffect, useState } from "react";
import { useOS } from "./OSContext";
import { osFetch } from "./api";

export function OSMembers() {
  const { orgId } = useOS();
  const [members, setMembers] = useState([]);
  useEffect(() => { if (orgId) osFetch(`/orgs/${orgId}/members`).then(setMembers).catch(() => {}); }, [orgId]);
  return (
    <div className="max-w-4xl" data-testid="os-members">
      <h1 className="font-display font-extrabold text-3xl mb-6">Members</h1>
      <div className="rounded-2xl border border-white/10 bg-[#0a0a0a] divide-y divide-white/5">
        {members.map((m) => (
          <div key={m.id} className="px-5 py-3 flex items-center gap-3 text-sm">
            <div className="w-8 h-8 rounded-full bg-[#0055FF]/20 text-[#00F0FF] flex items-center justify-center font-bold">{(m.user?.email || "?")[0].toUpperCase()}</div>
            <span className="text-white">{m.user?.email}</span>
            <span className="ml-auto flex gap-1">{(m.roles || []).map((r) => <span key={r} className="text-[10px] font-mono uppercase tracking-widest text-slate-400 border border-white/10 rounded-full px-2 py-0.5">{r}</span>)}</span>
          </div>
        ))}
        {members.length === 0 && <p className="p-5 text-slate-600 text-sm">Loading members…</p>}
      </div>
    </div>
  );
}

export function OSActivity() {
  const { orgId } = useOS();
  const [rows, setRows] = useState([]);
  useEffect(() => { osFetch("/activity?limit=100").then(setRows).catch(() => {}); }, [orgId]);
  return (
    <div className="max-w-4xl" data-testid="os-activity">
      <h1 className="font-display font-extrabold text-3xl mb-6">Activity</h1>
      <div className="rounded-2xl border border-white/10 bg-[#0a0a0a] divide-y divide-white/5">
        {rows.map((a) => (
          <div key={a.id} className="px-5 py-3 text-sm text-slate-300 flex items-center gap-3">
            <span className="text-[10px] font-mono text-slate-600 w-44 shrink-0">{new Date(a.created_at).toLocaleString()}</span>
            <span>{a.summary || `${a.verb} ${a.entity_type}`}</span>
          </div>
        ))}
        {rows.length === 0 && <p className="p-5 text-slate-600 text-sm">No activity yet.</p>}
      </div>
    </div>
  );
}

export function OSPlaceholder({ title }) {
  return (
    <div className="max-w-3xl" data-testid="os-placeholder">
      <h1 className="font-display font-extrabold text-3xl">{title}</h1>
      <div className="mt-6 rounded-2xl border border-dashed border-white/15 bg-[#0a0a0a] p-10 text-center">
        <p className="text-slate-400">This module ships in <span className="text-[#00F0FF] font-mono">Phase 1</span>.</p>
        <p className="text-slate-600 text-sm mt-2">Foundations first — the kernels powering this (versioning, linking, events, search, AI) are already live.</p>
      </div>
    </div>
  );
}
